export default "__VITE_ASSET__B2m71qHf__"